import React, { useState, useEffect, useCallback } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Form from "./components/Form";
import Dashboard from "./components/Dashboard";
import Magazyn from "./components/Magazyn";
import Kalkulator from "./components/Kalkulator";
import Login from "./components/Login";
import AcceptInvite from "./components/AcceptInvite";
import "./App.css";

function App() {
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [role, setRole] = useState(() => localStorage.getItem("role"));
  const [lastActivity, setLastActivity] = useState(Date.now());

  const SESSION_TIMEOUT = 60 * 60 * 1000; // 60 minut — zgodnie z backendem

  const handleLogin = (jwt, userRole) => {
    localStorage.setItem("token", jwt);
    localStorage.setItem("role", userRole);
    setToken(jwt);
    setRole(userRole);
    setLastActivity(Date.now());
  };

  const handleLogout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    setToken(null);
    setRole(null);
  }, []);

  // Sprawdza czy sesja wygasła po stronie frontendu
  useEffect(() => {
    if (!token) return;
    const interval = setInterval(() => {
      if (Date.now() - lastActivity > SESSION_TIMEOUT) {
        handleLogout();
      }
    }, 60000); // sprawdzaj co minutę
    return () => clearInterval(interval);
  }, [lastActivity, token, handleLogout, SESSION_TIMEOUT]);

  // Reset aktywności użytkownika
  useEffect(() => {
    const resetActivity = () => setLastActivity(Date.now());
    window.addEventListener("mousemove", resetActivity);
    window.addEventListener("keydown", resetActivity);
    window.addEventListener("click", resetActivity);
    return () => {
      window.removeEventListener("mousemove", resetActivity);
      window.removeEventListener("keydown", resetActivity);
      window.removeEventListener("click", resetActivity);
    };
  }, []);

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", paddingTop: "20px" }}>
      <Router>
        <Routes>
          {/* Publiczne */}
          <Route
            path="/login"
            element={!token ? <Login onLogin={handleLogin} /> : <Navigate to="/form" />}
          />
          {/* Strona aktywacji konta przez zaproszenie */}
          <Route path="/accept-invite" element={<AcceptInvite />} />

          {/* Chronione — każdy zalogowany */}
          <Route
            path="/form"
            element={token ? <Form onLogout={handleLogout} /> : <Navigate to="/login" />}
          />

          {/* Tylko admin */}
          {role === "admin" && (
            <>
              <Route
                path="/dashboard"
                element={token ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/login" />}
              />
              <Route
                path="/magazyn"
                element={token ? <Magazyn onLogout={handleLogout} /> : <Navigate to="/login" />}
              />
              <Route
                path="/kalkulator"
                element={token ? <Kalkulator /> : <Navigate to="/login" />}
              />
            </>
          )}

          {/* Root redirect */}
          <Route
            path="/"
            element={<Navigate to={token ? "/form" : "/login"} />}
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
